<template>

    <div class="sidebar">

        <div v-if="component === null && componentData === null" class="full-height">

            <div id="canvas-objects-list">

                <h3>{{ $t('objectsList.heading') }}</h3>

                <div v-if="preTemplate" v-once v-html="preTemplate"></div>

                <br>

                <CanvasObject v-if="item.getVisibility() !== 2 && item.isVisibleInSidebar()" v-for="(item, index) in objectsFromCurrentActive" :canvas-object="item" :canvas-objects-length="canvasObjectsLength"></CanvasObject>

                <div v-if="postTemplate" v-once v-html="postTemplate"></div>
            </div>

            <div v-if="showSaveOnWishList" class="option-button">
                <a class="btn btn-fullsize" @click="clickedSaveOnWishlistButton">{{ $t('formElements.showOnWishList.label') }}</a>
            </div>

            <div class="option-button">
                <a v-if="!load" class="btn btn-fullsize" @click="clickedAddToBasketButton">{{ $t('formElements.addToBasket.label') }}</a>
                <a v-if="load" class="btn btn-fullsize">

                    <img src="img/loader.gif" alt="">

                </a>
            </div>

        </div>

    </div>



</template>

<script>
    import TextObject from "./../structures/canvas-objects/TextObject";
    import ImageObject from "./../structures/canvas-objects/ImageObject";
    import TextboxObject from "../structures/canvas-objects/TextboxObject";
    import MaxWidthTextObject from "../structures/canvas-objects/MaxWidthTextObject";
    import ImageLimitedFormObject from "../structures/canvas-objects/ImageLimitedFormObject";
    import ImageGalleryObject from "../structures/canvas-objects/ImageGalleryObject";
    import moduleLoader from "../loader/Loader";
    import i18n from "../translation/i18n";

    export default {
        name: "SimpleCanvasObjectsList",
        components: {
          CanvasObject: () => moduleLoader.loadModule('CanvasObject', 'SimpleCanvasObject')
        },
        i18n,
        props: {
            currentActive: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => ({
            newElementType: null,
            newImage: null,
            component: null,
            componentData: null,
            load: false,
            showSaveOnWishList: false,
            preTemplate: null,
            postTemplate: null
        }),
        computed: {

            objectsFromCurrentActive() {
                return this.currentActive.canvas.getCanvasObjects().slice().reverse();
            },
            canvasObjectsLength() {
                return this.currentActive.canvas.getNumberOfCanvasObjects();
            },
            objectIsDeletable() {
                const deletable = this.componentData.getDeletable();
                return deletable || window['w2padmin'] === true;
            }

        },
        methods: {
            clickedAddToBasketButton() {
                this.load = true;
                this.$emit('save', { target: 'basket' });
            },
            clickedSaveOnWishlistButton() {
                this.$emit('save', { target: 'wishlist' });
            },
            clickedSaveAndDownload() {
                this.$emit('save', { target: 'download' });
            },
            chosenNewImage(event) {
                this.newImage = event.target.files[0];
            },
            loadComponent(file) {
                return () => import(`./canvas-object-types/${ file }`);
            },
            closeCanvasObjectView() {
                this.component = null;
                this.componentData = null;
            },
            deleteCanvasObject() {
                const id = this.componentData.getId();
                console.log(this.componentData);
                this.closeCanvasObjectView();
                this.currentActive.canvas.removeCanvasObjectById(id);
                this.currentActive.canvas.render();
            }
        },
        mounted() {

            window.EventHandler.$on(
                'clearobjectview',
                () => this.closeCanvasObjectView()
            );

            window.EventHandler.$on(
                'savefinished',
                () => this.load = false
            );

            if (window.hasOwnProperty('addToWishlist')) {
                this.showSaveOnWishList = true;
            }

            if (document.querySelector('#simpleSidebarPreTemplate')) {

                this.preTemplate = document.querySelector('#simpleSidebarPreTemplate').innerHTML;

            }

            if (document.querySelector('#simpleSidebarPostTemplate')) {

                this.postTemplate = document.querySelector('#simpleSidebarPostTemplate').innerHTML;

            }

        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/var";

    .option-button {
        padding: 2px 0;
    }

    .sidebar:first-child .option-button {
        padding: 4px 0 2px 0;
    }

    .sidebar:last-child .option-button {
        padding: 2px 0 0 0;
    }

    #customize-selected, #canvas-objects-list {
        flex-grow: 1;
        flex-shrink: 1;
        overflow: auto;
    }

    h3 {
        color: $blue-color;
        margin: 0;
        font-size: 1.3rem;
    }

    h4 {
        color: $blue-color;
        margin: 40px 0 5px 0;
    }

    p {
        color: $grey-font;
        font-size: 0.9em;

        b.display-block {
            display: block;
        }
    }

    .full-height {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px;
        box-sizing: border-box;
        background: $blue-color;
        color: #ffffff;
        font-weight: 600;
        font-size: 1rem;
        border-radius: 5px;

        &.btn-red {
            background-color: #D85846;
        }

        &[disabled=disabled] {
            background-color: darken($grey-font, 20);
            cursor: default;
        }

        &:hover {
            cursor: pointer;
        }
    }

    .btn-fullsize {
        height: 100%;
        width: 100%;
    }

    .select {
        box-sizing: border-box;
        width: 100%;
        border: 1px solid $grey-font;
        border-radius: 5px;
        position: relative;
        background-color: #ffffff;

        select {
            font-size: 0.8rem;
            border-radius: 5px;
            margin: 0;
            padding: 0.6rem 2rem 0.6rem 0.4rem;
            border: 0;
            box-sizing: border-box;
            width: 100%;
            -webkit-appearance: none;
            -moz-appearance: none;

            &::-ms-expand {
                display: none;
            }

            &:hover {
                cursor: pointer;
            }
        }

        &::after {
            position: absolute;
            font-family: "Material Icons";
            content: "arrow_drop_down";
            top: 50%;
            margin-top: -.5rem;
            right: .5rem;
            width: 1rem;
            height: 1rem;
            color: $blue-color;
            font-size: 1rem;
        }
    }

</style>
